import { graphql } from 'react-relay';

import { commit } from '../../mutations/commit';

const mutation = graphql`
  mutation deleteCashbackMutation(
    $input: DeleteCashbackInput!
    $byAuth0Id: String!
    $afterDate: Date!
    $beforeDate: Date!
    $bankAccountIdEq: String!
    $stateEq: String
    $storeIdEq: String
    $integrationItemIdEq: Int
    $nameCont: String
    $byMerchantNames: String
    $nameNotIContAll: String
  ) {
    deleteCashback(input: $input) {
      errorMessage
      destroyedCashbackId
      fastCash(byAuth0Id: $byAuth0Id) {
        ...FastCashContainer_fastCash
      }
      cashback {
        ...CashbackShow_cashback
      }
    }
  }
`;

const deleteCashback = (environment, params, listsId, args = {}) => {
  const { cashbackId, afterDate, beforeDate, byAuth0Id, bankAccountIdEq } =
    params;
  const variables = {
    input: { id: cashbackId },
    byAuth0Id,
    afterDate,
    beforeDate,
    bankAccountIdEq,
  };
  return commit(environment, {
    mutation,
    variables,
    configs: [
      {
        type: 'RANGE_DELETE',
        parentID: listsId,
        connectionKeys: [
          { key: 'FastCashContainer_fastCash' },
          { key: 'CashbackShow_cashback' },
        ],
        pathToConnection: ['fastCash', 'cashbacks'],
        deletedIDFieldName: 'destroyedCashbackId',
      },
    ],
    ...args,
  });
};

export default deleteCashback;
